module.exports = __webpack_public_path__ + "static/media/YM08_4.891b65aa.jpg";